<div class="mat-dialog-title">
  <div class="header-container">
    <img src="./assets/icons/beneficiary-icon.svg" />
    <p>Deletar Conntato</p>
  </div>
</div>

<div class="content-container">
  <p class="content">Tem certeza que deseja deletar o contato?</p>
</div>

<div mat-dialog-actions class="mat-dialog-actions">
  <div class="btn close-btn" (click)="close()">
    <span>Cancelar</span>
  </div>

  <div class="btn delete-btn" (click)="deleteContact()">
    <span>Deletar</span>
  </div>
</div>
